/**
 * Cake Topper Customizer — Puuki.fi
 * Istuu Shopify product-formin sisälle.
 * Käyttää Adobe Fonts (Typekit) -fontteja.
 * Ei luo omaa "lisää ostoskoriin" -nappia — käyttää Shopifyn omaa.
 */
(function () {
  'use strict';

  var MAX_CHARS = 15;

  var state = {
    lines: 1,
    texts: ['', '', '', ''],
    font: null,
    symbol: '', // Pisteiden koristelu: '' = tavalliset pisteet
  };

  // Kirjaimet joissa on piste (symbolilla korvattavissa): i, j, ä, ö + isot Ä/Ö.
  // Isot I ja J jäävät pois — niissä ei ole pistettä.
  var DOTTED_LETTERS = /[ijäöÄÖ]/;

  var container;
  var fonts = [];
  // Esikatselutekstin väri ja virheviesti voidaan yliajaa snippetistä
  // (esim. nimikyltin kyltti-mode: puunsävy + oma viesti)
  var fillColor = '#c9a84c';
  var errorText = 'Kirjoita koristeen teksti ennen ostoskoriin lisäämistä.';

  function init() {
    container = document.getElementById('cake-topper-customizer');
    if (!container) return;

    if (container.dataset.fill) fillColor = container.dataset.fill;
    if (container.dataset.errorText) errorText = container.dataset.errorText;

    // Parse font data
    var fontData = container.dataset.fonts;
    if (fontData) {
      try { fonts = JSON.parse(fontData); }
      catch (e) { console.error('CTC: fonttien parsinta epäonnistui', e); }
    }

    // Fontti valitaan aina asiakkaan omalla toiminnolla.

    // Snippet voi asettaa default-lines (esim. nimikilpi-mode → 2)
    var defaultLines = parseInt(container.dataset.defaultLines, 10);
    if (defaultLines >= 1 && defaultLines <= 4) {
      state.lines = defaultLines;
    }

    // Ensure a variant is selected (fix "Versiota ei löydy")
    ensureVariantSelected();
    moveQuantityAfterPreview();
    setupImageOverlay();
    renderFontButtons();
    bindEvents();
    syncSymbolFromNativeVariant();
    updatePreview();
    updateHiddenInputs();
    // Delay hiding native variant picker so Dawn can initialize first
    setTimeout(hideNativeVariantPicker, 500);

    // Validoi ennen Shopifyn add-to-cart-lomakkeen lähetystä
    var form = container.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!state.texts[0].trim()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var firstInput = container.querySelector('[data-ctc-text="0"]');
          if (firstInput) {
            firstInput.focus();
            firstInput.classList.add('ctc__input--error');
          }
          showError(errorText);
          return;
        }
        if (!state.font) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError('Valitse fontti ennen ostoskoriin lisäämistä.');
          return;
        }
        // Synkronoi kentät ennen Dawnin FormData-kaappausta.
        updateHiddenInputs();
      }, true);
    }

    // Lisätiedot-tekstikenttä: tyhjänä ei lähetetä tilaukselle (name pois, kenttä silti kirjoitettavissa)
    var lisatiedotEl = container.querySelector('textarea[name="properties[Lisätiedot]"]');
    if (lisatiedotEl) {
      var toggleLisatiedot = function () {
        if (lisatiedotEl.value.trim()) {
          lisatiedotEl.setAttribute('name', 'properties[Lisätiedot]');
        } else {
          lisatiedotEl.removeAttribute('name');
        }
      };
      lisatiedotEl.addEventListener('input', toggleLisatiedot);
      toggleLisatiedot();
    }
  }

  var overlayEl = null;

  function ensureVariantSelected() {
    // If no variant in URL, select the first radio and update URL
    var url = new URL(window.location.href);
    if (!url.searchParams.get('variant')) {
      var firstRadio = document.querySelector('variant-selects input[type="radio"]');
      if (firstRadio && !firstRadio.checked) {
        firstRadio.checked = true;
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Also set variant in URL from hidden input
      var hiddenId = document.querySelector('input[name="id"]');
      if (hiddenId && hiddenId.value) {
        url.searchParams.set('variant', hiddenId.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  function moveQuantityAfterPreview() {
    // Move Shopify's quantity selector after the font selector (last ctc section)
    var quantityEl = document.querySelector('.product-form__quantity, [class*="quantity"][class*="product"]');
    var lastSection = container.querySelector('.ctc__section:last-of-type');
    if (quantityEl && lastSection) {
      lastSection.after(quantityEl);
    }
  }

  function hideNativeVariantPicker() {
    // Hide Dawn's native variant-picker visually but keep select functional
    // Use CSS visibility+position instead of display:none so the select still initializes
    // HUOM: piilotus per fieldset, EI koko variant-selects — tuotteella voi olla
    // rivimäärän lisäksi muita optioita (esim. Väri) joiden pitää jäädä näkyviin.
    document.querySelectorAll('.product-form__input').forEach(function(el) {
      if (el.textContent.indexOf('rivi') !== -1 || el.querySelector('input[value="Tavalliset pisteet"]')) {
        el.style.position = 'absolute';
        el.style.width = '1px';
        el.style.height = '1px';
        el.style.overflow = 'hidden';
        el.style.clip = 'rect(0,0,0,0)';
      }
    });

    // Hide Qikify/tcustomizer old options
    document.querySelectorAll('.tcustomizer-field, [class*="tcustomizer"]').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  function setupImageOverlay() {
    // Product image overlay disabled — only small preview box used
  }

  function renderFontButtons() {
    var list = container.querySelector('#ctc-font-list');
    if (!list || fonts.length === 0) return;

    var html = '<button type="button" class="ctc__font-btn ctc__font-btn--active" data-ctc-font="-1" aria-pressed="true">Valitse fontti</button>';
    for (var i = 0; i < fonts.length; i++) {
      var f = fonts[i];
      var activeClass = '';
      var extraStyle = f.family.indexOf('variable') !== -1 ? ";font-variation-settings:'wght' 400" : '';
      html += '<button type="button" class="ctc__font-btn' + activeClass + '" data-ctc-font="' + i + '" aria-pressed="false">' +
        '<span class="ctc__font-preview" style="font-family:\'' + escapeAttr(f.family) + '\', sans-serif' + extraStyle + '">' +
        escapeHtml(state.texts[0] || 'Esimerkki') +
        '</span>' +
        '<span class="ctc__font-name">' + escapeHtml(f.label) + '</span>' +
        '</button>';
    }
    list.innerHTML = html;
    updateFontCounter();
  }

  function updateFontCounter() {
    var counter = container.querySelector('#ctc-font-counter');
    if (!counter) return;
    var active = container.querySelector('.ctc__font-btn--active');
    var idx = active ? parseInt(active.dataset.ctcFont, 10) + 1 : 0;
    counter.textContent = idx > 0 ? idx + ' / ' + fonts.length : 'Valitse fontti';
  }

  function bindEvents() {
    // Font scroll arrows — shift selection + scroll
    var fontListEl = container.querySelector('#ctc-font-list');
    var prevBtn = container.querySelector('#ctc-fonts-prev');
    var nextBtn = container.querySelector('#ctc-fonts-next');
    if (fontListEl && prevBtn && nextBtn) {
      function currentFontIndex() {
        var active = fontListEl.querySelector('.ctc__font-btn--active');
        return active ? parseInt(active.dataset.ctcFont, 10) : -1;
      }
      function selectFontByIndex(idx) {
        if (idx < 0) idx = fonts.length - 1;
        if (idx >= fonts.length) idx = 0;
        var btn = fontListEl.querySelector('[data-ctc-font="' + idx + '"]');
        if (btn) {
          btn.click();
          btn.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
        }
      }
      prevBtn.addEventListener('click', function () {
        selectFontByIndex(currentFontIndex() - 1);
      });
      nextBtn.addEventListener('click', function () {
        selectFontByIndex(currentFontIndex() + 1);
      });
    }

    // Rivimäärä
    container.querySelectorAll('[data-ctc-lines]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.lines = parseInt(this.dataset.ctcLines, 10);
        container.querySelectorAll('[data-ctc-lines]').forEach(function (b) {
          b.classList.toggle('ctc__row-btn--active', parseInt(b.dataset.ctcLines, 10) === state.lines);
        });
        updateTextFields();
        updatePreview();
        updateHiddenInputs();
        updateVariant();
      });
    });

    // Tekstikentät
    container.querySelectorAll('[data-ctc-text]').forEach(function (input) {
      input.addEventListener('input', function () {
        var idx = parseInt(this.dataset.ctcText, 10);
        state.texts[idx] = this.value;
        this.classList.remove('ctc__input--error');
        hideError();
        updateCharCount(idx);
        updateFontPreviews();
        updatePreview();
        updateHiddenInputs();
      });
    });

    // Pisteiden symboli
    container.querySelectorAll('[data-ctc-symbol]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.symbol = this.dataset.ctcSymbol || '';
        container.querySelectorAll('[data-ctc-symbol]').forEach(function (b) {
          var active = (b.dataset.ctcSymbol || '') === state.symbol;
          b.classList.toggle('ctc__symbol-btn--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateSymbolNote();
        updateHiddenInputs();
        updateSymbolVariant();
      });
    });

    // Fonttinapit — käytetään event delegationia koska renderöidään dynaamisesti
    var fontList = container.querySelector('#ctc-font-list');
    if (fontList) {
      fontList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ctc-font]');
        if (!btn) return;
        var idx = parseInt(btn.dataset.ctcFont, 10);
        state.font = fonts[idx] || null;
        fontList.querySelectorAll('[data-ctc-font]').forEach(function (b) {
          b.classList.toggle('ctc__font-btn--active', parseInt(b.dataset.ctcFont, 10) === idx);
          b.setAttribute('aria-pressed', String(parseInt(b.dataset.ctcFont, 10) === idx));
        });
        updateFontCounter();
        updatePreview();
        updateHiddenInputs();
      });
    }
  }

  function updateFontPreviews() {
    var displayText = state.texts[0] || 'Esimerkki';
    container.querySelectorAll('.ctc__font-preview').forEach(function (el) {
      el.textContent = displayText;
    });
  }

  function updateTextFields() {
    for (var i = 0; i < 4; i++) {
      var field = container.querySelector('[data-ctc-field="' + i + '"]');
      if (field) {
        field.style.display = i < state.lines ? '' : 'none';
        if (i >= state.lines) {
          state.texts[i] = '';
          var input = field.querySelector('[data-ctc-text]');
          if (input) input.value = '';
        }
      }
    }
  }

  function updateCharCount(idx) {
    var counter = container.querySelector('[data-ctc-count="' + idx + '"]');
    if (!counter) return;
    var len = state.texts[idx].length;
    counter.textContent = len + ' / ' + MAX_CHARS;
    counter.classList.toggle('ctc__char-count--over', len > MAX_CHARS);
  }

  // Näytä huomautus jos symboli on valittu mutta teksteissä ei ole pisteellisiä kirjaimia
  function updateSymbolNote() {
    var note = container.querySelector('[data-ctc-symbol-note]');
    if (!note) return;
    var allText = state.texts.slice(0, state.lines).join('');
    var show = state.symbol && allText.trim() && !DOTTED_LETTERS.test(allText);
    note.style.display = show ? '' : 'none';
  }

  function updatePreview() {
    var activeTexts = state.texts.slice(0, state.lines).filter(function (t) { return t.trim(); });
    var fontFamily = state.font ? state.font.family : 'sans-serif';
    updateSymbolNote();

    // Update image overlay (text on product photo)
    if (overlayEl) {
      if (activeTexts.length === 0) {
        overlayEl.innerHTML = '';
      } else {
        var vbWidth = 500;
        var lineHeight = 42;
        var topPad = 5;
        var totalTextHeight = activeTexts.length * lineHeight;
        var vbHeight = topPad + totalTextHeight + 5;

        var svgHtml = '<svg viewBox="0 0 ' + vbWidth + ' ' + vbHeight + '" style="width:85%;max-width:500px;filter:drop-shadow(0 2px 10px rgba(0,0,0,0.5))" xmlns="http://www.w3.org/2000/svg">';

        var isVariable = fontFamily.indexOf('variable') !== -1;
        var variableStyle = isVariable ? "font-variation-settings:'wght' 400;" : '';

        for (var i = 0; i < activeTexts.length; i++) {
          var y = topPad + (i + 1) * lineHeight - 10;
          var fontSize = calculateFontSize(activeTexts[i], vbWidth, 40);
          svgHtml += '<text x="' + (vbWidth / 2) + '" y="' + y + '" ' +
            'text-anchor="middle" ' +
            'style="font-family:\'' + escapeAttr(fontFamily) + '\', sans-serif;' + variableStyle + '" ' +
            'font-size="' + fontSize + '" ' +
            'fill="' + fillColor + '">' +
            escapeHtml(activeTexts[i]) +
            '</text>';
        }

        svgHtml += '</svg>';

        overlayEl.innerHTML = svgHtml;
      }
    }

    // Also update the small preview box in the form (fallback)
    var svg = container.querySelector('#ctc-preview-svg');
    var placeholder = container.querySelector('#ctc-preview-placeholder');
    if (!svg) return;

    if (activeTexts.length === 0 || !state.font) {
      svg.style.display = 'none';
      if (placeholder) {
        placeholder.style.display = '';
        placeholder.textContent = activeTexts.length ? 'Valitse fontti nähdäksesi esikatselun' : 'Kirjoita teksti nähdäksesi esikatselun';
      }
      return;
    }

    svg.style.display = '';
    if (placeholder) placeholder.style.display = 'none';

    var vbW = 400;
    var lh = 42;
    var tp = 8;
    var tth = activeTexts.length * lh;
    var vbH = tp + tth + 5;

    svg.setAttribute('viewBox', '0 0 ' + vbW + ' ' + vbH);

    var isVar = fontFamily.indexOf('variable') !== -1;
    var varStyle = isVar ? "font-variation-settings:'wght' 400;" : '';

    var html = '';
    for (var j = 0; j < activeTexts.length; j++) {
      var yy = tp + (j + 1) * lh - 6;
      var fs = calculateFontSize(activeTexts[j], vbW, 40);
      html += '<text x="' + (vbW / 2) + '" y="' + yy + '" ' +
        'text-anchor="middle" ' +
        'style="font-family:\'' + escapeAttr(fontFamily) + '\', sans-serif;' + varStyle + '" ' +
        'font-size="' + fs + '" ' +
        'fill="' + fillColor + '">' +
        escapeHtml(activeTexts[j]) +
        '</text>';
    }

    svg.innerHTML = html;
  }

  function calculateFontSize(text, viewBoxWidth, base) {
    var maxWidth = viewBoxWidth - 40;
    var baseSize = base || 80;
    var charWidth = baseSize * 0.52;
    var estimatedWidth = text.length * charWidth;
    if (estimatedWidth > maxWidth) {
      return Math.floor(baseSize * (maxWidth / estimatedWidth));
    }
    return baseSize;
  }

  function updateHiddenInputs() {
    setHidden('properties[Teksti rivi 1]', state.texts[0] || '');
    setHidden('properties[Teksti rivi 2]', state.lines >= 2 ? (state.texts[1] || '') : '');
    setHidden('properties[Teksti rivi 3]', state.lines >= 3 ? (state.texts[2] || '') : '');
    setHidden('properties[Teksti rivi 4]', state.lines >= 4 ? (state.texts[3] || '') : '');
    setHidden('properties[Fontti]', state.font ? state.font.label : '');
    // Variantillisilla tuotteilla symboli näkyy jo varianttiotsikossa → ei tupla-propertyä
    setHidden('properties[Pisteiden symboli]', hasSymbolVariants() ? '' : state.symbol);

  }

  function setHidden(name, value) {
    // Etsi ensin customizer-divin sisältä, sitten lähimmästä formista
    var input = container.querySelector('input[name="' + name + '"]');
    if (!input) {
      var form = container.closest('form');
      if (form) input = form.querySelector('input[name="' + name + '"]');
    }
    if (input) {
      input.value = value;
      // Tyhjä property ei saa päätyä tilausriville
      input.disabled = !value;
    }
  }

  // Onko tuotteella Pisteet-variantti-optio? (symboli veloitetaan variantin kautta)
  function hasSymbolVariants() {
    return !!document.querySelector('variant-selects input[type="radio"][value="Tavalliset pisteet"], variant-radios input[type="radio"][value="Tavalliset pisteet"]');
  }

  // Valitse symbolia vastaava Pisteet-variantti (jos tuotteella on optio)
  function updateSymbolVariant() {
    var target = state.symbol || 'Tavalliset pisteet';
    var radios = document.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === target) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          var label = radios[i].nextElementSibling;
          if (label && label.tagName === 'LABEL') label.click();
        }
        return;
      }
    }
  }

  // Sivu ladattu suoraan symbolivariantin URL:lla → synkkaa napit variantista
  function syncSymbolFromNativeVariant() {
    var radios = document.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked && (radios[i].value === 'Sydän' || radios[i].value === 'Tähti')) {
        state.symbol = radios[i].value;
        container.querySelectorAll('[data-ctc-symbol]').forEach(function (b) {
          var active = (b.dataset.ctcSymbol || '') === state.symbol;
          b.classList.toggle('ctc__symbol-btn--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
    }
  }

  function updateVariant() {
    var lineLabels = { 1: '1 rivi', 2: '2 riviä', 3: '3 riviä', 4: '4 riviä' };
    var targetLabel = lineLabels[state.lines] || '1 rivi';

    // Find radio inputs inside variant-selects or variant-radios
    var radios = document.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === targetLabel) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        // Also click the label to trigger Dawn's JS
        var label = radios[i].nextElementSibling;
        if (label && label.tagName === 'LABEL') label.click();
        return;
      }
    }
  }

  function showError(msg) {
    var el = container.querySelector('#ctc-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ctc-error';
      el.className = 'ctc__error';
      container.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = '';
  }

  function hideError() {
    var el = container.querySelector('#ctc-error');
    if (el) el.style.display = 'none';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return str.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
